


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { PcapParser } from '../..//parser/pcapparser'
import TraceWrapper from '../../data/TraceWrapper';
import axios from 'axios'
import { Ngtcp2LogParser } from '../../parser/Ngtcp2LogParser'
import FileSettings from './FileSettings.vue'
import FColorSettings from './FColorSettings.vue'

export default {
  name: "GeneralSettings",
  computed: {
    frametables(){
      return this.$store.state.framecolortables.getAllTableNames()
    },
    selectedframetable(){
      return this.$store.state.framecolortables.getSelectedTableName()
    }
  },
  methods: {
    selectFrameTable(tablename: string){
      this.$store.dispatch('switchFrameColorTable', tablename);
    },
    expandDataSettings(){
      let settings = document.getElementById('datasettings')
      let classes = settings.classList

      if (classes.contains('show')){
        classes.remove('show')
      }
      else
        classes.add('show')
    }
  },
  components: {
    FileSettings,
    FColorSettings
  }
}
